import React from "react";
import { DayPicker } from "react-day-picker";
import { ru, enGB } from "date-fns/locale";
import { getCurrentLang } from "../i18n/LanguageContext";
import "react-day-picker/style.css";

const SimpleCalendar = ({ selected, onSelect }) => {
  return (
    <div className="w-full">
      <style jsx global>{`
        .rdp {
          --rdp-cell-size: 40px;
          --rdp-accent-color: #059669;
          --rdp-background-color: #f0fdf4;
          --rdp-accent-color-dark: #047857;
          --rdp-range-start-color: #059669;
          --rdp-range-end-color: #059669;
          --rdp-range-middle-color: #d1fae5;
          margin: 0;
        }
        
        .rdp-month {
          width: 100%;
        }
        
        .rdp-table {
          width: 100%;
          max-width: none;
        }
        
        .rdp-head_cell {
          font-weight: 500;
          font-size: 14px;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          padding: 12px 0;
        }
        
        .rdp-cell {
          padding: 2px;
        }
        
        .rdp-button {
          border: none;
          background: none;
          font-size: 14px;
          font-weight: 500;
          width: 40px;
          height: 40px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          cursor: pointer;
          color: #374151;
        }
        
        .rdp-button:hover:not(.rdp-day_selected):not(.rdp-day_range_start):not(.rdp-day_range_end) {
          background-color: #f3f4f6;
        }
        
        .rdp-day_today {
          background-color: #dbeafe !important;
          color: #2563eb !important;
          font-weight: 600;
          border: 2px solid #3b82f6;
        }
        
        .rdp-day_selected, .rdp-day_range_start, .rdp-day_range_end {
          background-color: #059669 !important;
          color: white !important;
          font-weight: 600;
        }
        
        .rdp-day_range_middle {
          background-color: #d1fae5 !important;
          color: #047857 !important;
        }
        
        .rdp-day_outside {
          color: #d1d5db;
        }
        
        .rdp-day_disabled {
          color: #e5e7eb;
          cursor: not-allowed;
        }
        
        .rdp-caption {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 24px;
          position: relative;
          padding: 0;
        }
        
        .rdp-caption_label {
          font-size: 18px;
          font-weight: 600;
          color: #111827;
          margin: 0 40px;
          text-transform: capitalize;
        }
        
        .rdp-nav {
          position: absolute;
          display: flex;
          align-items: center;
        }
        
        .rdp-nav_button {
          border: none;
          background: none;
          width: 32px;
          height: 32px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          color: #6b7280;
        }
        
        .rdp-nav_button:hover {
          background-color: #f3f4f6;
          color: #374151;
        }
        
        .rdp-nav_button_previous {
          left: 0;
        }
        
        .rdp-nav_button_next {
          right: 0;
        }
        
        .rdp-weekdays {
          margin-bottom: 8px;
        }
      `}</style>
      <DayPicker
        mode="range"
        selected={selected}
        onSelect={onSelect}
        locale={getCurrentLang() === "en" ? enGB : ru}
        weekStartsOn={1}
        showOutsideDays={true}
        fixedWeeks={true}
      />
    </div>
  );
};

export default SimpleCalendar;